import { createClient } from '@supabase/supabase-js';


// Initialize database client
const supabaseUrl = 'https://rukihqmbdewdykqzmgck.databasepad.com';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImIxZmU2MmIwLTQ1MjQtNGYwZi05OTM2LTRjYWIxYjI2N2U5ZSJ9.eyJwcm9qZWN0SWQiOiJydWtpaHFtYmRld2R5a3F6bWdjayIsInJvbGUiOiJhbm9uIiwiaWF0IjoxNzc0OTc1NzcyLCJleHAiOjIwOTAzMzU3NzIsImlzcyI6ImZhbW91cy5kYXRhYmFzZXBhZCIsImF1ZCI6ImZhbW91cy5jbGllbnRzIn0.v2-7ERkNRlx1q9JOTVAV3mqW1QA0Z0tl8su1SyGQh98';
const supabase = createClient(supabaseUrl, supabaseKey);


export { supabase };